<template>
<el-dialog v-if="visible" title="拟定审批单" width="80%" :visible.sync="visible" :key="timer" append-to-body @close="cancel()">
    <el-table :data="partList" row-key="id" size="mini" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }">
       <!-- <el-table-column type="selection" width="55">
        </el-table-column> -->
       <!-- <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
                {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
            </template>
        </el-table-column> -->
        <el-table-column prop="partCode" header-align="center" align="left" label="零件编号">
        </el-table-column>
        <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
        </el-table-column>
        <el-table-column prop="cancelFlag" header-align="center" align="left" label="取消标识">
          <template slot-scope="scope">
                <span>
                    {{ cancelFlagStatusFormat(scope.row.cancelFlag) }}
                </span>
          </template>
        </el-table-column>
        <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量">
        </el-table-column>
        <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格">
        </el-table-column>
        <el-table-column prop="supplyStatus" header-align="center" align="center" label="供货状态" width="80">
            <template slot-scope="scope">
                <span>
                    {{ supplyStatusFormat(scope.row.supplyStatus) }}
                </span>
            </template>
        </el-table-column>
        <!-- <el-table-column prop="rfqSupplierList" header-align="center" align="right" label="中标供应商">
            <template >
                <span>
                    {{ this.rfqSupplierList }}
                </span>
            </template>
        </el-table-column> -->
<!--        <el-table-column prop="rfqSupplierList" label="中标供应商" header-align="center" align="left" width="200">-->
<!--            <template slot-scope="scope">-->
<!--                <el-select placeholder="下拉查看中标供应商" v-model="scope.row.selectedSuppliers" size="small">-->
<!--                    <el-option v-for="item in scope.row.rfqSupplierList" :key="item.rfqSupplierCode" :label="item.rfqSupplierName" :value="item.rfqSupplierCode"/>-->
<!--                </el-select>-->
<!--            </template>-->
<!--        </el-table-column>-->
      <el-table-column prop="rfqSupplierList" label="中标供应商" header-align="center" align="left" width="200">
        <template slot-scope="scope">
          {{ scope.row.rfqSupplierList? scope.row.rfqSupplierList.map(item => item.rfqSupplierName).join(', ') : '' }}
        </template>
      </el-table-column>
        <el-table-column header-align="center" align="left" width="190" label="操作">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="selectPartList(scope.row)" :disabled="scope.row.cancelFlag === 1" icon="el-icon-edit">
                    选择中标供应商
                </el-button>
            </template>
        </el-table-column>

    </el-table>

    <rfq-supplier-part v-if="this.partVisible" ref="rfqSupplierPart" @confirm="confirmPrepare"/>
    <rfq-supplier-part-all v-if="this.partAllVisible" ref="rfqSupplierPartAll" @confirm="confirmAllPrepare"/>
    <div slot="footer">
      <el-button type="primary" @click="selectPartAllList()">中标供应商一键选择</el-button>
      <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" v-if="isAuth('sourcing:rfq:newbutton')" :loading="submitting" @click="confirm()">确认拟定</el-button>
    </div>
</el-dialog>
</template>

<script>
import {
    getQUOTATION_STATUS_VALUE,
    SUPPLY_STATUS,
    CANCEL_FLAG,
    getLabelByValue,
} from '@/utils/const'
import RfqSupplierPart from "./rfq-supplier-part";
import RfqSupplierPartAll from "./rfq-supplier-part-all";
// import moment from 'moment'
import _ from 'lodash'; // 引入 lodash 库用于深拷贝

export default {
    props: {
        //供应商列表数据
        basicFormData: Object,
        partList: Array,
        supplierList: Array,
        viewFlag: Boolean,
    },
    computed: {
        confirmDisable() {
            if (!this.summaryList) return true
            const checked = this.summaryList.filter(v => v.rfqSupplyRadio)
            if (checked.length === 0) return true
            let sum = 0
            checked.forEach(v => {
                sum += v.rfqSupplyRadio
            })
            return !(sum === 100)
        }
    },
    data() {
        return {
            rfqId: '',
            visible: false,
            submitting: false,
            summaryList: [],
            partVisible:false,
            partAllVisible:false,
            dataListSelections: [],
            rfqSupplierParamList:[],
            timer:'',
            rfqSupplier:'',
            localPartList: _.cloneDeep(this.partList) // 使用 lodash 深拷贝
        }
    },
    components: {
        RfqSupplierPart,
        RfqSupplierPartAll
    },
    mounted() {},
    methods: {
        init(summaryList,rfqId) {
            console.log(this.partList);
            this.visible = true
            this.submitting = false
            this.summaryList = summaryList
            this.rfqId = rfqId
            this.rfqSupplierParamList=[]
        },
        confirm() {
            if (this.submitting) return
            // //判断零件是否选择了中标供应商，没选择给提示
            // for (let key = 0; key < this.partList.length; key++) {
            //     debugger
            //     if(this.partList[key].rfqSupplierList == undefined || this.partList[key].rfqSupplierList.length == 0) {
            //         //this.preparedApproveFlag = false
            //         return this.$message.error("请先选择中标供应商，再确认拟定")
            //     }
            // }
            console.log('确认提交的partList',this.partList)
            const validParts = this.partList.filter(part => part.rfqSupplierList && part.rfqSupplierList.length > 0 && part.cancelFlag !== 1);
            console.log('过滤后的validParts',validParts)
            if (validParts.length === 0) {
              return this.$message.error("请先为非取消状态的零件选择中标供应商");
            }
            this.submitting = true
            this.$emit('confirm', validParts)
            this.visible = false
        },
        confirmPrepare(params){
          console.log('查看所选供应商信息params',params);
          console.log('当前零件集合partList',this.partList)
          const partIndex = this.partList.findIndex(part => part.id === params.row.id);

            // for (let key = 0; key < this.partList.length; key++) {
            //     if(params.row.id === this.partList[key].id){
            //         debugger
            //         this.partList[key].rfqSupplierList =  params.suppliers
            //       // 提取所有供应商的 rfqSupplierCode
            //       const supplierCodes = params.suppliers.map(supplier => supplier.rfqSupplierCode);
            //       // 将合并后的数组赋给 selectedSuppliers
            //         this.partList[key].selectedSuppliers =  supplierCodes
            //     }
            // }
          if (partIndex !== -1) {
            this.partList[partIndex].rfqSupplierList = params.suppliers;
            // 提取所有供应商的 rfqSupplierCode
            //const supplierCodes = params.suppliers.map(supplier => supplier.rfqSupplierCode);
            // 将合并后的数组赋给 selectedSuppliers
            // this.partList[partIndex].selectedSuppliers = supplierCodes;
            // console.log('选择展示selectedSuppliers',this.partList[partIndex].selectedSuppliers);
          }
            console.log('选择完的零件集合partList',this.partList);
            // 刷新当前Dialog
            this.timer = new Date().getTime();
            // this.showDetailDialog(this.id);
        },
          confirmAllPrepare(params) {
            console.log('查看所选供应商信息params',params);
            console.log('当前零件集合partList',this.partList)
            // 更新 partList 中每个元素的 rfqSupplierList
            this.partList.forEach((item, index) => {
              item.rfqSupplierList = params.suppliers;
              // 提取所有供应商的 rfqSupplierCode
              // const supplierCodes = params.suppliers.map(supplier => supplier.rfqSupplierCode);
              // // 将合并后的数组赋给 selectedSuppliers
              // item.selectedSuppliers =  supplierCodes
              // console.log('选择展示selectedSuppliers',item.selectedSuppliers);
            });

            console.log('选择完的零件集合partList',this.partList);
            // 刷新当前 Dialog
            this.timer = new Date().getTime();
          },
        cancelFlagStatusFormat(value) {
          if (value === null || value === undefined) {
            return "";
          }
          return getLabelByValue(CANCEL_FLAG, value);
        },
        supplyStatusFormat(value) {
          if (value === null || value === undefined) {
                return "";
            }
            return getLabelByValue(SUPPLY_STATUS, value);
        },
        handleCheckChange(val, row) {
            if (val) {
                if (this.summaryList.findIndex(v => v.rfqSupplyRadio !== 0) > -1) {
                    row.rfqSupplyRadio = 100
                } else {
                    row.rfqSupplyRadio = 0
                }
            } else {
                row.rfqSupplyRadio = 0
            }
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections.push(val);
        },
        getStatus(status) {
            return getQUOTATION_STATUS_VALUE(status)

        },
        selectPartList(row){
            this.partVisible = true
            this.$nextTick(() => {
                this.$refs.rfqSupplierPart.init(row,this.rfqId,this.summaryList,this.basicFormData)
            })
        },
      selectPartAllList(){
        const row = this.partList[0];
        this.partAllVisible = true
        this.$nextTick(() => {
          this.$refs.rfqSupplierPartAll.init(row,this.rfqId,this.summaryList,this.basicFormData)
        })
      },
        cancel() {
            this.visible = false
            this.$emit('update:visible', false)
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
    },
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}
</style>
